import React from "react";
import PropTypes from "prop-types";
import { Segment, Header, Icon, Label, Grid, Message } from "semantic-ui-react";

export const PatronInfo = ({
  patronInfo,
  allLoansCount,
  overdueCount,
  fineCount = 0,
  overrideData,
}) => {
  if (!patronInfo) return null;

  return (
    <Segment>
      <Header as="h3" color="orange">
        <Icon name="user" />
        Patron Information
        {overrideData && (
          <Label color="orange" size="small" style={{ marginLeft: "10px" }}>
            <Icon name="edit" />
            Has Override Data
          </Label>
        )}
      </Header>
      <Grid columns={2} stackable>
        <Grid.Column>
          <p>
            <strong>Name:</strong> {patronInfo.name}
          </p>
          <p>
            <strong>Email:</strong> {patronInfo.email}
          </p>
          <p>
            <strong>Patron ID:</strong> {patronInfo.pid}
          </p>
        </Grid.Column>
        <Grid.Column>
          <p>
            <strong>Total Loans:</strong> {allLoansCount}
          </p>
          <p>
            <strong>Overdue Returns:</strong> {overdueCount}
          </p>
          <p>
            <strong>Fine Records:</strong> {fineCount}
          </p>
        </Grid.Column>
      </Grid>

      {overrideData && (
        <Message color="orange" size="small">
          <Message.Header>Override Information</Message.Header>
          <p>
            This patron has custom fine amounts that override the standard
            calculation.
          </p>
          {overrideData.useManualTotal && (
            <p>
              <strong>Manual Total:</strong> ₱
              {overrideData.totalAmount?.toFixed(2) || "0.00"}
            </p>
          )}
        </Message>
      )}
    </Segment>
  );
};

PatronInfo.propTypes = {
  patronInfo: PropTypes.object,
  allLoansCount: PropTypes.number.isRequired,
  overdueCount: PropTypes.number.isRequired,
  fineCount: PropTypes.number,
  overrideData: PropTypes.object,
};
